import { useState } from "react"
import JSZip from "jszip"
import { GalleryImage } from "@/features/gallery/hooks/useGalleryImages"

const useZipDownload = () => {
  const [downloading, setDownloading] = useState(false)

  const downloadAsZip = async (images: GalleryImage[]) => {
    if (images.length === 0 || downloading) return
    setDownloading(true)

    try {
      const zip = new JSZip()

      await Promise.all(
        images.map(async (img, index) => {
          const response = await fetch(img.url)
          const blob = await response.blob()
          const ext = blob.type.split("/")[1] || "jpg"
          const name = (img.productName || "image").replace(/[^a-z0-9]+/gi, "_").replace(/^_|_$/g, "")
          zip.file(`${name}_${index + 1}.${ext}`, blob)
        })
      )

      const content = await zip.generateAsync({ type: "blob" })
      const url = URL.createObjectURL(content)
      const a = document.createElement("a")
      a.href = url
      a.download = "gallery_images.zip"
      a.click()
      URL.revokeObjectURL(url)
    } finally {
      setDownloading(false)
    }
  }

  return { downloading, downloadAsZip }
}

export { useZipDownload }
